<template>

<app-view-list-field :is-sticky="isSticky" :field="field" :filter="filter">

    <core-gamename :game="item.game" :collection="item.collection" class="name" />

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky']

}

</script>

<style scoped>

.name {
	color: #333;
	font-weight: 500;
	font-size: 16px;
	line-height: 16px;
}

.is-mobile .name {
	font-size: 14px;
}

.is-desktop .name:hover {
	text-decoration: underline;
}

</style>